import { useContext, useEffect } from 'react';

import MealItemForm from './MealItemForm';
import classes from './MealItem.module.css';
import CartContext from '../../../store/cart-context';
import { IMAGE_BY_NAME } from '../../../data/mealMedia';
import normalizeName from '../../../utils/normalizeName';

const MealItem = (props) => {
  const cartCtx = useContext(CartContext);

  const price = `$${props.price.toFixed(2)}`;
  const normalizedName = normalizeName(props.name);
  const imageSrc = IMAGE_BY_NAME[normalizedName];

  useEffect(() => {
    if (!imageSrc && process.env.NODE_ENV !== 'production') {
      console.warn('Missing image for meal:', props.name);
    }
  }, [imageSrc, props.name]);

  const addToCartHandler = amount => {
    cartCtx.addItem({
      id: props.id,
      name: props.name,
      amount: amount,
      price: props.price
    });
  };

  return (
    <li className={classes.meal}>
      {imageSrc ? (
        <div className={classes.imageWrapper}>
          <img src={imageSrc} alt={props.name} className={classes.image} />
        </div>
      ) : (
        <div className={classes.imageFallback} />
      )}
      <div className={classes.details}>
        <h3>{props.name}</h3>
        <div className={classes.description}>{props.description}</div>
        <div className={classes.price}>{price}</div>
      </div>
      <div>
        <MealItemForm onAddToCart={addToCartHandler} />
      </div>
    </li>
  );
};

export default MealItem;
